// extracted by mini-css-extract-plugin
export default {"form":"TaskDetail_form__+9uOR"};